import { render, staticRenderFns } from "./ListExercismExercises.vue?vue&type=template&id=85789094&scoped=true&"
import script from "./ListExercismExercises.vue?vue&type=script&lang=js&"
export * from "./ListExercismExercises.vue?vue&type=script&lang=js&"
import style0 from "./ListExercismExercises.vue?vue&type=style&index=0&id=85789094&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85789094",
  null
  
)

export default component.exports